import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './WrongAnswerDialog.module.scss';
import classNames from 'classnames';
import Dialog from './Dialog';

export default class WrongAnswerDialog extends Component {
    static propTypes = {
        visible: PropTypes.bool,
        onClose: PropTypes.func.isRequired,
    };

    render() {
        const {visible, onClose, children} = this.props;

        return (
            <Dialog
                visible={visible}
                renderIcon={this.renderIcon}
                okButtonLabel='Try Again!'
                onClose={onClose}
            >
                {children}
            </Dialog>
        );
    }

    renderIcon = () => {
        const {visible} = this.props;

        const iconClassName = classNames(styles.wrongAnswerIcon, {
            [styles.wrongAnswerIconVisibled]: visible,
        });

        return <div className={iconClassName} />;
    };
}
